import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    
    span {
        font-size: 14px;
        font-weight: 400;
        color: ${theme.textDark};
        margin-top: 20px;
    }

    button {
        width: 100%;
    }
`;

export { Container };